module.exports = __webpack_public_path__ + "static/media/white_keyboard.c00e1949.png";